import { Timesheets } from '../types/timers'
import { useDatabase } from '../composables/database'

type TimesheetsModelReturn = {
  writeTimesheets: (data: any) => Promise<void>
  loadTimesheets: () => Promise<Timesheets>
  clearTimesheets: () => Promise<void>
}
/**This will only consist of data returned from the server, which should be
 * timesheets within the current payperiod (determined by server).
 */
export const TimesheetsModel = (): TimesheetsModelReturn => {
  const { query, run } = useDatabase()
  const loadTimesheets = async () => {
    const sql = `
        SELECT * FROM timesheets;
        `
    return await query(sql)
      .catch((error) => console.log(`Error loading timesheets: ${error}`))
      .then((timesheets) => {
        if (timesheets && typeof timesheets !== 'undefined' && timesheets.length > 0) {
          const data = JSON.parse(timesheets[0]['timesheets_data'])
          return data
        } else {
          return []
        }
      })
  }

  const writeTimesheets = async (data: any) => {
    const sql = `
        INSERT OR REPLACE INTO timesheets ('id', 'timesheets_data')
        VALUES ( 0, ? )
    `
    const values = [JSON.stringify(data)]
    await run(sql, values).catch((error) => console.log(`Error writing timesheets to DB: ${error}`))
  }

  const clearTimesheets = async () => {
    const sql = `
        DELETE FROM timesheets;
    `
    await run(sql, []).catch((error) => console.log(`Error deleting timesheets: ${error}`))
  }

  return {
    writeTimesheets,
    loadTimesheets,
    clearTimesheets,
  }
}
